module.exports = __webpack_public_path__ + "img/Event_Icon_TapTakeover_Blue.bd53a455.png";